// Temporary payment pause. Keep this aligned with functions/api/pay/start.js.
export const PAYMENTS_TEMPORARILY_UNAVAILABLE = true;

// Temporary public routing while the first-party checkout is unavailable.
// Keep the server-side redirect flag in functions/submit-your-music/index.js aligned.
export const SUBMITHUB_DIRECT_TEMPORARY_MODE = true;
export const SUBMITHUB_DIRECT_URL = 'https://www.submithub.com/direct/ivagonzo';
// Temporary owner/testing alias for the preserved first-party submission page.
// Remove this route together with the temporary SubmitHub mode rollback.
export const SUBMITHUB_DIRECT_PREVIEW_PATH = '/submit-your-music-beta';
export const PUBLIC_SUBMISSION_URL = SUBMITHUB_DIRECT_TEMPORARY_MODE
  ? SUBMITHUB_DIRECT_URL
  : '/submit-your-music';
export const PUBLIC_SUBMISSION_TARGET = SUBMITHUB_DIRECT_TEMPORARY_MODE ? '_blank' : undefined;
export const PUBLIC_SUBMISSION_REL = SUBMITHUB_DIRECT_TEMPORARY_MODE ? 'noopener' : undefined;

const RAW_API_BASE =
  process.env.REACT_APP_BACKEND_BASE_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  '';

export const PAYMENT_AVAILABILITY_NOTIFY_ENDPOINT = buildApiUrl(
  '/payment-availability-notify'
);

function buildApiUrl(path) {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  const base = String(RAW_API_BASE || '').trim().replace(/\/$/, '');

  if (!base) return `/api${cleanPath}`.replace(/\/api\/+/, '/api/');
  if (base === '/api') return `${base}${cleanPath}`.replace(/\/api\/+/, '/api/');
  if (/\/api$/i.test(base)) return `${base}${cleanPath}`.replace(/\/api\/+/, '/api/');
  return `${base}/api${cleanPath}`.replace(/\/api\/+/, '/api/');
}
